<div class="status-dialog">
  <h2 class="status-dialog__title">{{ 'components.documentStatusDialog.title' | translate }}</h2>
  <mat-radio-group class="status-dialog__options" [(ngModel)]="selectedStatusId">
    @for (option of options; track option.id) {
      <mat-radio-button [value]="option.id">
        {{ option.id }} - {{ option.name }}
        @if (option.labelKey) {
          ({{ option.labelKey | translate }})
        }
      </mat-radio-button>
    }
  </mat-radio-group>
  <div class="dialog-actions">
    <div class="dialog-actions-column">
      <button color="warn" mat-flat-button class="cancel" (click)="cancel()">
        {{ 'components.documentStatusDialog.cancel' | translate }}
      </button>
    </div>
    <div class="dialog-actions-column dialog-actions-column-right">
      <button color="primary" mat-flat-button class="confirm" [disabled]="!selectedStatusId" (click)="confirm()">
        {{ 'components.documentStatusDialog.confirm' | translate }}
      </button>
    </div>
  </div>
</div>
